<div class="logs-container">
  <frg-cards class="logs-card" [title]="pageTitle">
    <div class="inside-card-wrapper">
      <div class="filters-wrapper">
        <form>
          <frg-form-input id="finess" label="Finess" type="text" [formGroup]="logsForm"
            [control]="logsForm.get('finess')"></frg-form-input>

          <frg-form-input id="rpps" label="RPPS" type="text" [formGroup]="logsForm"
            [control]="logsForm.get('rpps')"></frg-form-input>
          <frg-form-input id="dateDebut" label="Date de début" type="date" [formGroup]="logsForm"
            [control]="logsForm.get('dateDebut')"></frg-form-input>

          <frg-form-input id="dateFin" label="Date de fin" type="date" [formGroup]="logsForm"
            [control]="logsForm.get('dateFin')"></frg-form-input>
          <span class="mss-pro-filters">Filtre par type de document pour les envois et la consultation du DMP et les
            envois MSS:</span>
          <frg-form-input id="typeDocument" label="Type de document" type="ngSelect" [selectValue]="typeDocuments"
            [formGroup]="logsForm" [control]="logsForm.get('typeDocument')"></frg-form-input>
          <!-- Filtres dédiés MSS Pro -->
          <span class="mss-pro-filters">Filtres dédiés MSS Pro:</span>
          <frg-form-input id="finessDestinataire" label="Finess (Destinataire MSS Pro)" type="text"
            [formGroup]="logsForm" [control]="logsForm.get('finessDestinataire')"></frg-form-input>

          <frg-form-input id="rppsDestinataire" label="RPPS (Destinataire MSS Pro)" type="text" [formGroup]="logsForm"
            [control]="logsForm.get('rppsDestinataire')"></frg-form-input>
        </form>
      </div>
      <div class="logs-table-wrapper">
        <div class="title-logs">Indicateurs Globaux</div>
        <div class="card">
          <div class="title">Nombre de prises en charge</div>
          <div class="button-container">
            <div class="value">{{ totalConsultations }}</div>
          </div>
        </div>
      </div>

      <div class="logs-table-wrapper">
        <div class="title-logs">Envois réussis</div>
        <div class="card">
          <div class="title">DMP INS non qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsDMPNonQualifie }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsDmpNonQualifie }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">DMP INS qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsDMPQualifie }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsDmpQualifie }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">MSS Patient INS non qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsMSSPatientNonQualifie }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsMssPatientNonQualifie }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">MSS Patient INS qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsMSSPatientQualifie }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsMssPatientQualifie }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">MSS Pro INS non qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsMSSProNonQualifie }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsMssProNonQualifie }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">MSS Pro INS qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsMSSProQualifie }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsMssProQualifie }} %</div>
          </div>
        </div>
      </div>

      <div class="logs-table-wrapper">
        <div class="title-logs">Envois non réussis</div>
        <div class="card">
          <div class="title">DMP INS non qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsDMPNonQualifieEchec }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsDmpNonQualifieEchec }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">DMP INS qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsDMPQualifieEchec }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsDmpQualifieEchec }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">MSS Patient INS non qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsMSSPatientNonQualifieEchec }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsMssPatientNonQualifieEchec }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">MSS Patient INS qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsMSSPatientQualifieEchec }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsMssPatientQualifieEchec }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">MSS Pro INS non qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsMSSProNonQualifieEchec }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsMssProNonQualifieEchec }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">MSS Pro INS qualifié</div>
          <div class="button-container">
            <div class="value">{{ totalLogsMSSProQualifieEchec }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsMssProQualifieEchec }} %</div>
          </div>
        </div>
        <frg-button class="export-button" [type]="'button'" (activated)="export()"
          [backgroundColor]="'var(--darkest-primary)'">
          Exporter
        </frg-button>
      </div>
      <div class="logs-table-wrapper">
        <div class="title-logs">Statistiques de consultation du DMP</div>
        <div class="card">
          <div class="title">Consultation(s) du DMP</div>
          <div class="button-container">
            <div class="value">{{ totalLogsDMPLecture }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsDMPLecture }} %</div>
          </div>
        </div>
        <div class="card">
          <div class="title">Echecs de consultation du DMP</div>
          <div class="button-container">
            <div class="value">{{ totalLogsDMPLectureEchec }}</div>
            <div class="rate" *ngIf="totalConsultations > 0">{{ tauxLogsDMPLectureEchec }} %</div>
          </div>
        </div>
      </div>
      <div class="logs-table-wrapper">
        <div class="title-logs">Statistiques des identités patients</div>
        <div class="card">
          <div class="title">Identité(s) provisoire(s)</div>
          <div class="button-container">
            <div class="value">{{ totalPatientsProvisoire }}</div>
            <div class="rate" *ngIf="tauxProvisoire > 0">({{ tauxProvisoire }} %)</div>
          </div>
        </div>
        <div class="card">
          <div class="title">Identité(s) récupérée(s)</div>
          <div class="button-container">
            <div class="value">{{ totalPatientsRecuperees }}</div>
            <div class="rate" *ngIf="tauxRecuperees > 0">({{ tauxRecuperees }} %)</div>
          </div>
        </div>
        <div class="card">
          <div class="title">Identité(s) validée(s)</div>
          <div class="button-container">
            <div class="value">{{ totalPatientValidees }}</div>
            <div class="rate" *ngIf="tauxValidees > 0">({{ tauxValidees }} %)</div>
          </div>
        </div>
        <div class="card">
          <div class="title">Identité(s) qualifiée(s)</div>
          <div class="button-container">
            <div class="value">{{ totalPatientsQualifiees }}</div>
            <div class="rate" *ngIf="tauxQualifiees > 0">({{ tauxQualifiees }} %)</div>
          </div>
        </div>
        <div class="card">
          <div class="title">Id. qualifiée(s) par procédure transitoire</div>
          <div class="button-container">
            <div class="value">{{ totalPatientsQualifieesTransitoires }}</div>
            <div class="rate" *ngIf="tauxQualifieesTransitoires > 0">({{ tauxQualifieesTransitoires }} %)</div>
          </div>
        </div>
      </div>


      <div class="logs-table-wrapper">
        <div class="title-logs">Indicateurs - Exercice coordonné</div>
        <div class="indicateurs-grid">
          <div class="card card-indicateur">
            <div class="title">Patients inclus dans un protocole pluriprofessionnel</div>
            <div class="button-container">
              <div class="value">{{ indicateurProtocoles }}</div>
            </div>
          </div>

          <div class="card card-indicateur">
            <div class="title">Enfants âgés de 0 à 16 ans ayant bénéficié d'au moins 2 soins de médecins généralistes associés de la structure</div>
            <div class="button-container">
              <div class="value" *ngIf="!isSpecialiste">{{ indicateurEnfants }}</div>
              <div class="value" *ngIf="isSpecialiste">N/A</div>
            </div>
          </div>

          <div class="card card-indicateur">
            <div class="title">Patients de plus de 16 ans ayant déclaré comme « médecin traitant » un des médecins associés de la structure</div>
            <div class="button-container">
              <div class="value" *ngIf="!isSpecialiste">{{ indicateurMedecinTraitant }}</div>
              <div class="value" *ngIf="isSpecialiste">N/A</div>
            </div>
          </div>

          <div class="card card-indicateur">
            <div class="title">Patients ayant un compte-rendu réunions pluriprofessionnels / patients médecins traitants de la structure présentant une affection de longue durée ou âgés de plus de 75 ans</div>
            <div class="button-container">
              <div class="value">{{ indicateurRcp }} / {{ ratioRcp }}</div>
              <div class="rate" *ngIf="ratioRcp > 0">({{ (indicateurRcp / ratioRcp * 100) | number:'1.0-1' }} %)</div>
            </div>
          </div>
        </div>

        <frg-button class="export-button" [type]="'button'" (activated)="exportStatsExerciceCoordonne()"
          [backgroundColor]="'var(--darkest-primary)'">
          Exporter en CSV
        </frg-button>
      </div>

    </div>
  </frg-cards>
</div>